import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Users } from 'lucide-react';
import { socialNetworks } from '../utils/socialNetworks';

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } }
};

const SocialLinks = () => {
  return (
    <section
      id="socials"
      className="section-padding bg-glow-container"
      style={{
        background: 'linear-gradient(180deg, #050b14 0%, #081222 50%, #050b14 100%)',
        position: 'relative'
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 2 }}>

        {/* Header */}
        <div className="text-center" style={{ marginBottom: '55px' }}>
          <span className="badge-gold">
            <Users size={16} color="var(--mga-gold)" />
            Rejoignez la Communauté
          </span>

          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 2.8rem)',
            color: 'var(--mga-white)',
            marginTop: '10px',
            marginBottom: '15px'
          }}>
            Suivez-nous sur les <span style={{ color: 'var(--mga-gold)' }}>réseaux sociaux</span>
          </h2>

          <p style={{
            maxWidth: '680px',
            margin: '0 auto',
            color: 'var(--mga-slate-300)',
            fontSize: '1.05rem',
            lineHeight: '1.6'
          }}>
            Restez informés, échangez avec la communauté et suivez le déploiement du projet MonAlerte sur nos différents canaux d'expression.
          </p>
        </div>

        {/* Grid of Social Media Cards */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-80px' }}
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '24px'
          }}
        >
          {socialNetworks.map((net) => {
            const IconComp = net.icon;

            return (
              <motion.div
                key={net.id}
                variants={cardVariants}
                className="glass-card"
                style={{
                  padding: '30px 26px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  background: 'rgba(11, 31, 58, 0.45)',
                  border: '1px solid rgba(242, 184, 7, 0.3)',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.3), 0 0 20px rgba(37, 211, 102, 0.08)'
                }}
              >
                <div>
                  {/* Top Bar with Icon and Badge */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '20px'
                  }}>
                    <div style={{
                      width: '52px',
                      height: '52px',
                      borderRadius: '14px',
                      backgroundColor: `${net.color}18`,
                      border: `1px solid ${net.color}40`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: net.color
                    }}>
                      <IconComp size={26} />
                    </div>

                    <span style={{
                      fontSize: '0.78rem',
                      fontWeight: 700,
                      padding: '4px 12px',
                      borderRadius: '100px',
                      backgroundColor: 'rgba(37, 211, 102, 0.15)',
                      color: '#25D366',
                      border: '1px solid rgba(37, 211, 102, 0.3)'
                    }}>
                      {net.badge}
                    </span>
                  </div>

                  <span style={{
                    fontSize: '0.82rem',
                    color: 'var(--mga-slate-400)',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>
                    {net.category}
                  </span>

                  <h3 style={{
                    color: 'var(--mga-white)',
                    fontSize: '1.3rem',
                    marginTop: '4px',
                    marginBottom: '12px',
                    fontFamily: 'var(--font-display)',
                    fontWeight: 700
                  }}>
                    {net.name}
                  </h3>

                  <p style={{
                    color: 'var(--mga-slate-300)',
                    fontSize: '0.94rem',
                    lineHeight: '1.6',
                    margin: 0
                  }}>
                    {net.description}
                  </p>
                </div>

                <div style={{ marginTop: '24px' }}>
                  <a
                    href={net.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button-primary"
                    style={{
                      width: '100%',
                      padding: '12px 18px',
                      fontSize: '0.92rem',
                      boxSizing: 'border-box'
                    }}
                  >
                    <span>{net.buttonText}</span>
                    <ExternalLink size={16} />
                  </a>
                </div>
              </motion.div>
            );
          })}
        </motion.div>

      </div>
    </section>
  );
};

export default SocialLinks;
